<template>
    <div class="se-autocomplete">
        <div class="autocomplete-input-outer">
            <input type="text" :value="value" @focus="getQueryString" @input="getQueryString" :placeholder="placeholder">
        </div>
        <div v-if="showList" class="autocomplete-list-outer">
            <ul>
                <li v-for="(item, index) in list" :key="index" @click="selectItem(item)">{{ item }}</li>
            </ul>
        </div>
    </div>
</template>
<script>

export default {
    name: 'SeAutocomplete',
    props:{
        fetchsuggestions: {
            type: Function,
            required: true
        },
        placeholder: {
            type: String
        },
        value: {
            type: String
        }
    },
    data(){
        return {
            showList: false,
            list: []
        }
    },
    methods: {
        selectItem(item){
            this.showList = false; 

            this.$emit('select', item)
        },
        getQueryString($event){
            this.$emit('input', $event.target.value);
            this.$nextTick(() => {
                this.fetchsuggestions(this.value, (result) => {
                    this.list = result;
                    result.length > 0 ? this.showList = true : this.showList = false
                })
            })
        }
    }
}
</script>
<style lang="less" scoped>
.se-autocomplete {
    width: 100%;
    position: relative;
    .autocomplete-input-outer {
    }
    .autocomplete-list-outer{
        position: absolute;
        top: 43px;
        left: 0;
        width: 100%;
        z-index: 10000;
        background: #fff;
        max-height: 120px;
        overflow: scroll;
        border: 1px solid #ccc;
        box-sizing: border-box;
        ul {            
            li {
                height: 40px;
                line-height: 40px;
                padding: 0 10px;
                &:hover {
                    background: #f5f7fa;
                }
            }
        }
    }
}
</style>
